import { brandsOpenApi } from '@constants';
import { axiosBoa } from '@utils';
import * as get from 'lodash/get';
import * as isEmptyObj from 'lodash/isEmpty';
import { getParent, types } from 'mobx-state-tree';
import { createStoreAction } from './utils';

export const InsightsStore = types
    .model('InsightsStore', {
        pending: false,
        usMapData: types.maybeNull(types.frozen()),
        data: types.maybeNull(types.frozen())
    })
    .views((self) => ({
        get root() {
            return getParent(self);
        },
        get isEmpty() {
            return isEmptyObj(self.data) || self.error;
        },
        get demographicsChartsData() {
            return get(this.data, 'demographics', {});
        },
        get financialChartsData() {
            return get(this.data, 'financial', {});
        },
        get purchaseChartsData() {
            return get(this.data, 'purchase', {});
        },
        get interestsChartsData() {
            return get(this.data, 'interests', {});
        }
    }))
    .actions((self) => {
        const action = createStoreAction(self);

        return {
            getInsightsData: action(
                function* getInsightsData() {
                    self.pending = true;

                    const rawUsMapData = yield fetch('https://klickly.s3.amazonaws.com/states-10m.json');
                    self.usMapData = yield rawUsMapData.json();

                    const data = yield axiosBoa.get(brandsOpenApi.performance.insights.get);
                    self.data = {
                        demographics: get(data, 'data.demographics', {}),
                        financial: get(data, 'data.financial', {}),
                        purchase: get(data, 'data.purchase', {}),
                        interests: get(data, 'data.interests', {})
                    };
                },
                { onFinally: () => (self.pending = false) }
            ),
            getUSMapData: action(function* getUSMapData() {
                const rawUsMapData = yield fetch('https://klickly.s3.amazonaws.com/states-10m.json');
                self.usMapData = yield rawUsMapData.json();
            })
        };
    });
